<template>
    <div class="part-options" :class="[partOptionsClass, {'part-options-fragrance-slider': optionTileType === 3}]">
        <ul ref="categoriesSelector" class="categories" v-if="shouldShowCategories">
            <li v-for="(category, idx) in categories" :class="selectedPartClass(idx)">
                <a href="javascript:void(0);" @click="selectPart(idx)">
                    <span class="category-name">{{ category.name }}</span>
                </a>
            </li>
        </ul>

        <div class="category-indicator-scrim" v-if="shouldShowCategories" >
            <div id="categoryIndicator" class="category-indicator" :class="indicatorClass" :style="computedIndicatorStyle"></div>
        </div>

        <transition :name="sliderTransitionName">
            <div v-if="optionTileType === 3" class="fragrance-options-slider">
                <div class="fragrance-slider-body">
                    <VueSlickCarousel v-bind="sliderSettings" ref="carousel" @beforeChange="onBeforeChange">
                        <div class="slider-gap" v-if="!isMobile && !isSmallDesktop"></div>
                        <template v-for="(category, cid) in categories">
                            <div v-for="(option, id) in category.options"
                                :data-cid="cid"
                                :key="'optionList' + cid"
                                :id="'optionList' + cid"
                                :style="getOptionDimenions()"
                                :class="{ 'selected' : checkIfCurrentSlide(cid, id, currentSlide), 'slider-item': true }">

                                <div class="content-wrapper">
                                    <span class="error-message" v-if="!option.available && outOfStockType == 'bar'">
                                        <span class="error-badge"></span>
                                        {{ resources.notInStockShort }}
                                    </span>
                                    <image-layer wrapperClass="option-image" :image="option.thumb"></image-layer>
                                    <span class="option-category">{{ category.name }}</span>
                                    <span class="option-name">{{ option.name }}</span>
                                    <div class="option-more-wrapper">
                                        <span class="option-more" @click="onClickReadMore(option)">{{ resources.learnMore }}</span>
                                    </div>
                                </div>

                            </div>
                        </template>
                        <div class="slider-gap" v-if="!isMobile && !isSmallDesktop"></div>
                    </VueSlickCarousel>
                </div>

                <slider-controls
                    :showLeftArrow="showLeftArrow"
                    :showRightArrow="showRightArrow"
                    @clickArrowLeft="onClickArrowLeft()"
                    @clickArrowRight="onClickArrowRight()">
                </slider-controls>
            </div>
        </transition>

        <transition name="part-options-transition">
            <div id="optionsSlider" class="part-options-slider" :class="{'has-statusbar': shouldIncreaseHeight, 'has-wide-tiles': optionTileType === 4}" v-show="shouldShowOptions" v-if="optionTileType !== 3">
                <template v-for="(category, cid) in categories">
                    <h4 class="category-name" v-if="isDesktop && categories.length > 1">{{ category.name }}</h4>
                    <ul class="options"
                        :style="getListStyle(category.options.length)"
                        :data-cid="cid"
                        :key="'optionList' + cid"
                        :id="'optionList' + cid">

                        <li v-for="(option, id) in category.options" :class="optionClass(cid, id)" :style="getOptionDimenions()">
                            <a href="javascript:void(0)" @click="selectOption(cid, id)" :class="{'bottle-wrapper': optionTileType === 2, 'bottle-cap-wrapper': optionTileType === 5}">
                                <span class="error-badge" v-if="!option.available && outOfStockType == 'badge'"></span>
                                <span class="error-message" v-if="!option.available && outOfStockType == 'bar'">
                                    <span class="error-badge"></span>
                                    {{ resources.notInStockShort }}
                                </span>
                                <image-layer v-if="optionTileType === 2 || optionTileType === 4 || optionTileType === 5" wrapperClass="option-thumb" :image="option.thumb"></image-layer>
                                <span class="option-name">{{ option.name }}</span>
                                <span class="option-excerpt" v-if="optionTileType === 1 || optionTileType === 4">{{option.excerpt}}</span>
                                <span class="option-more" v-if="optionTileType === 1" @click="onClickReadMore(option)">{{ resources.readMore }}</span>
                                <span class="option-more" v-if="optionTileType === 4" @click="onClickReadMore(option)">{{ resources.learnMore }}</span>
                            </a>
                        </li>
                    </ul>
                </template>
            </div>
        </transition>
    </div>
</template>

<script src="./part-options.js"></script>
